import styles from './index.module.scss'

export function ImageCardSkeleton() {
  return <div className={styles.imageCard} />
}
